import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ProdutoService, ProdutoUnidadeService } from 'almoxarifado-lib';
import { BaseResourceItemsComponent, CompraItem, EddyAutoComplete, FuncaoService, GlobalService, Produto, ProdutoUnidade } from 'eddydata-lib';
import { takeUntil } from 'rxjs/operators';
import { CompraItemService } from '../service/compra-item.service';
import * as toastr from 'toastr';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-compra-item',
  templateUrl: './compra-item.component.html'
})
export class CompraItemComponent extends BaseResourceItemsComponent<CompraItem>{

  @ViewChild('inpQuantidade') public inpQuantidade: ElementRef;

  public imaskValor = {
    mask: Number,
    scale: 5,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  @Input() somenteVisualizar: boolean = false;

  public produtoAutoComplete: EddyAutoComplete<Produto>;

  public produtoUnidades: ProdutoUnidade[] = [];

  constructor(private produtoUnidadeService: ProdutoUnidadeService,
    private produtoService: ProdutoService,
    public funcaoService: FuncaoService,
    public globalService: GlobalService,
    public compraItemService: CompraItemService) {
    super(new CompraItem(), compraItemService);
  }

  protected afterInit(): void {
    this.carregarAutoCompletes();
  }

  protected afterEdit(item: CompraItem) {
    if (!item.produto_unidade)
      item.produto_unidade = new ProdutoUnidade();
    if (!item.ordem)
      item.ordem = this.lista.length + 1;
    this.carregarUnidades(item);
  }

  protected validSave(item: CompraItem): boolean {
    if (!item.quantidade) {
      toastr.warning('Informe a quantidade para o item!');
      return false;
    }
    if (!item.valor_unitario) {
      toastr.warning('Informe o valor unitario para o item!');
      return false;
    }
    return true;
  }

  protected beforeSave(item: CompraItem): void { }

  public carregarUnidades(item: CompraItem) {
    if (!item.produto_unidade?.produto)
      return;
    this.produtoUnidadeService.filtrar(1, -1, {
      'produto.id': item.produto_unidade.produto.id,
      ativo: true,
      relations: ['produto', 'unidade']
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if (!data)
          return;
        this.produtoUnidades = data.content;
        if (this.produtoUnidades && this.produtoUnidades.length > 0)
          item.produto_unidade = this.produtoUnidades[0];
      }, (error) => toastr.error(error.error.payload));
  }


  private carregarAutoCompletes() {
    this.produtoAutoComplete = new EddyAutoComplete(null, this.produtoService,
      'id', ['codigo', 'nome'], { orderBy: 'codigo,nome' }, { number: ['id', 'codigo'], text: ['codigo', 'nome'] }
    );
  }

  public somaItens(): { quantidade?: number, unitario?: number, desconto?: number, icmsipi?: number, valor_total?: number } {

    let soma = {
      quantidade: 0,
      unitario: 0,
      desconto: 0,
      icmsipi: 0,
      valor_total: 0
    };

    if (!this.lista || this.lista.length === 0)
      return soma;
    for (let item of this.lista) {
      soma['quantidade'] += +item.quantidade;
      soma['unitario'] += +item.valor_unitario;
      soma['desconto'] += +item.valor_desconto;
      soma['icmsipi'] += +item.valor_icmsipi;
      soma['valor_total'] += +item.quantidade * +item.valor_unitario - (+item.valor_icmsipi + +item.valor_desconto);
    }
    return soma;
  }

  public refazerOrdenacao(event: CdkDragDrop<string[]>) {
    if (this.disabled())
      return;
    moveItemInArray(this.lista, event.previousIndex, event.currentIndex);
    this.lista = this.lista.map((l, i) => {
      l.ordem = i + 1;
      return l;
    });
    this.reordenar();
  }

  public reordenar() {
    this.lista = this.lista.sort((a, b) => a.ordem - b.ordem);
  }

  public campoFoco(): ElementRef {
    return this.inpQuantidade;
  }
}